import React from 'react';
import { SvgBaseProps } from './interfaces';

interface LogoProps extends SvgBaseProps {
  style?: any;
}

const SVGLogo = ({ color = '#FFF', className, style }: LogoProps) => (
  <svg
    width='121'
    height='104'
    viewBox='0 0 121 104'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    style={style}
  >
    <path
      d='M44.0764 25.6627L26.9462 9.99658H23.9393L8.4525 20.6895L5.62502 20.4096L0.680435 24.9882V27.8587L8.28746 34.9778L4.69923 38.3723V41.372L16.1026 52.0434H33.9002L44.0836 42.4485L44.0764 25.6627ZM41.2058 41.207L32.7735 49.1728H17.2508L7.58418 40.1233V39.6066L10.4117 36.9441L14.5812 40.8481L16.5476 38.7526L3.55102 26.6244V26.2512L6.62965 23.3806L9.21325 23.639L24.8363 12.8743H25.8338L41.2058 26.933V41.207Z'
      fill={color}
    />
    <path
      d='M115.905 9.08529L101.933 14.6829L110.315 6.64528V3.55942L106.318 -0.0288086H102.88L84.8602 18.0128L81.3724 14.5251H78.1861L67.5076 25.1893V42.4127L77.6981 52.0076H95.5173L109.87 37.6547V34.5186L102.887 25.4476L118.575 18.4649L120.053 16.1971L118.152 10.7L115.905 9.08529ZM116.623 16.1541L98.3735 24.2706L106.985 35.4588V36.5065L94.3259 49.1729H78.8391L70.3781 41.2071V26.3949L79.3773 17.4028H80.1883L82.8364 20.0509L78.143 24.7371L80.174 26.7681L104.072 2.87051H105.256L107.473 4.85117V5.41814L94.8498 17.5248L97.0601 19.7352L115.554 12.3291L115.755 12.4726L116.896 15.7738L116.623 16.1541Z'
      fill={color}
    />
    <path
      d='M48.6909 43.6758L35.7733 55.8757V84.6605L38.163 87.0503H43.1865V95.0879L45.5691 97.4776H50.7362V101.26L53.1187 103.649H58.7666L61.1564 101.26V96.0782H66.3162L68.6988 93.6885V77.6778L69.3662 78.3452H73.8659L76.2484 75.9554V56.3996L62.9146 43.6758H48.6909ZM73.4425 74.7642L72.7248 75.4818H70.5719L68.7131 73.6303V64.3583H65.8425V92.4613L65.1249 93.1789H61.8597L61.142 92.4613V69.023H58.2714V100.04L57.5538 100.757H54.2813L53.5637 100.04V69.023H50.6931V93.8966L49.9754 94.6142H46.703L45.9854 93.8966V69.023H43.1148V83.4405L42.3971 84.1581H39.2323L38.5147 83.4405V57.0814L49.6741 46.5464H61.6372L73.2845 57.634L73.4425 74.7642Z'
      fill={color}
    />
  </svg>
);

export default SVGLogo;
